var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer_copyright"}},[_c('p',{staticClass:"footer_paragraph"},[_vm._v(_vm._s(_vm.$t("footer.copyright", { currentYear: _vm.currentYear })))])])
}
var staticRenderFns = []

export { render, staticRenderFns }